import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRotateLeft01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.178 15a9.6 9.6 0 0 0 9.122 6.6A9.6 9.6 0 1 0 3.984 7.2M6.9 8.4H2.1V3.6"
    />
  </svg>
);
export default SvgArrowRotateLeft01;
